export const MAX_FILE_SIZE = 100 * 1024 * 1024; // 100MB in bytes

export const ACCEPTED_FILE_TYPES = [
  '.fbx', // autodesk
  '.glb', // gltf binary
  '.gltf', // gltf
  '.ma', // maya
  '.mb', // maya binary
  '.obj', // wavefront
];

// Tabs:
export const DEFAULT_TAB = 'avatar-picker-default';
export const CUSTOM_TAB = 'avatar-picker-custom';

// Subpanels:
export const HAND_PICKER_SUBPANEL_KEY = 'hand-picker';
export const FACE_PICKER_SUBPANEL_KEY = 'face-picker';
export const AVATAR_PICKER_SUBPANEL_KEY = 'avatar-picker';

export const GEN_SUBPANEL_KEY = 'creation-options';
export const UPLOAD_CHARACTER_SUBPANEL_KEY = 'upload-character';

export const UPLOAD_CHARACTER_TAB = 'upload-character-tab';
export const UPLOAD_CHARACTER_HISTORY_TAB = 'upload-character-history-tab';

export const CHAR_GENERATION_PREFIX = 'char-generation';

export const CHAR_GEN_DESKTOP_MIN_WIDTH = 1024;
